import { makeStyles } from "tss-react/mui";

export const useTooltipInfoContentStyles = makeStyles()((theme) => ({}));
